import { FunctionComponent } from 'react';

const CallbackError: FunctionComponent = () => (
  <div className="text-center">
    <p>An error occured during sign in.</p>
  </div>
);

export default CallbackError;
